import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';


import { CustomListboxComponent } from './custom-listbox.component';
import { CustomIconsModule } from 'src/app/theme/shared/components/custom-icons/custom-icons.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        CustomIconsModule
    ],
    declarations: [
        CustomListboxComponent
    ],
    exports: [
        CustomListboxComponent
    ]
})
export class CustomListboxModule { }
